import { Stack, Text } from '@leroy-merlin-br/backyard-react'

import { PhoneContent } from './components/PhoneContent'
import * as S from './styled'

export interface NavProps {
  isWhatsappEnabled: boolean
}

const Nav = ({ isWhatsappEnabled }: NavProps) => {
  const currentIsWhatsappIsEnabled = Boolean(isWhatsappEnabled)

  return (
    <S.Wrapper>
      <Stack space="byte">
        <Text isBold noMargin>
          Compre pelo Telefone
        </Text>

        <Stack space="bit">
          {currentIsWhatsappIsEnabled && (
            <PhoneContent
              iconType="whatsapp"
              link="https://api.whatsapp.com/send?phone=551140071380"
              phoneNumber="(11) 4007-1380"
              locale="Nacional"
            />
          )}
          <PhoneContent
            link="tel:+55-11-4007-1380"
            phoneNumber="4007-1380"
            locale="Capitais"
          />
          <PhoneContent
            link="tel:+55-0800-602-1380"
            phoneNumber="0800-602-1380"
            locale="Demais regiões"
          />
        </Stack>
      </Stack>
    </S.Wrapper>
  )
}

export default Nav
